module.exports = __webpack_public_path__ + "img/side seam.38de3490.png";